import { Benefit } from '@witkac/kartamiejska-shared';
import { BenefitResource, benefitResource } from '@witkac/kartamiejska-resources';

import available from './availableBenefits.module';
import store from '@/store/store';
import { EntityModule } from '../entity.module';

/**
 * Moduł usług partnera
 *
 * @export
 * @class BenefitsModule
 * @extends {AbstractModule<BenefitResource>}
 */
export class BenefitsModule extends EntityModule<Benefit, BenefitResource> {
  public modules = {
    available
  };

  constructor() {
    super(benefitResource);

    this.mutations = {
      ...this.mutations,
      /**
       * Dodaje usługę do listy
       *
       * @param localState stan lokalny
       * @param data dane do wysłania do API
       */
      add(): void {
        store.dispatch('partners/benefits/list', { partnerId: (store.state as any).partners.id, count: 0 });
      },
      /**
       * Aktualizuje usługę na liście
       *
       * @param localState stan lokalny
       * @param data dane do wysłania do API
       */
      update(): void {
        store.dispatch('partners/benefits/list', { partnerId: (store.state as any).partners.id, count: 0 });
      }
    };
  }
}

export default new BenefitsModule();
